var render, staticRenderFns
import script from "./allDemand.vue?vue&type=script&lang=js&"
export * from "./allDemand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccc81e6c",
  null
  
)

export default component.exports